import bottomBar from '../components/bottonBar.vue';
export default {
  components: {
    bottomBar
  }
};